module.exports = __webpack_public_path__ + "img/logo-micinn-aei.ee81d6d8.jpg";